import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { storeActivityIndicator, storeFastFirm } from "../../../redux/reducers/authSlice";
import { CompanyService } from "../../../services/CompanyService";
import toast from "react-hot-toast";
import { Helpers } from "../../../helpers/Helpers";
import { IntegrationSettingService } from "../../../services/IntegrationSettingService";
import { AddIntegrationSettingResponse } from "../../../models/response/integrationSetting/AddIntegrationSettingResponse";
import { GetIntegrationSettingByIdResponse } from "../../../models/response/integrationSetting/GetIntegrationSettingByIdResponse";

const IntegrationSettingAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ayarlar > Entegrasyon Ayarları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [integrationSettingId, setIntegrationSettingId] = useState<string | undefined>(undefined);
    const [selectedCurrentCompany, setSelectedCurrentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedIntegration, setSelectedIntegration] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [integrationValues, setIntegrationValues] = useState<any>(undefined);
    // Şifre türü alanlardan hangileri açıkça gösteriliyor (ekranı gören herkes görmesin diye varsayılan gizli).
    const [shownSecrets, setShownSecrets] = useState<string[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetIntegrationSettingByIdResponse = await IntegrationSettingService.getIntegrationSettingById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setIntegrationSettingId(response.data.integrationSettingId);

                if (response.data.companyId && response.data.companyName)
                    setSelectedCurrentCompany({ label: response.data.companyName, value: response.data.companyId });

                if (response.data.integrationId && response.data.integrationName)
                    setSelectedIntegration({ label: response.data.integrationName, value: response.data.integrationId });

                var splittedKeys = response.data.integrationKey.split('|;|');
                var splittedValues = response.data.text.split('\n');

                var obj: any = {}

                for (var i = 0; i < splittedValues.length; i++) {
                    var _value = splittedValues[i].split(splittedKeys[i] + " =")[1].trim();

                    obj[splittedKeys[i]] = _value;
                }

                setIntegrationValues(obj);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveIntegrationSetting = async () => {
        try {
            for (var i = 0; i < Object.keys(integrationValues).length; i++) {
                var _key = Object.keys(integrationValues)[i];

                if (Helpers.isEmpty(integrationValues[_key])) {
                    toast.error(_key + ' alanını doldurunuz!')
                    return;
                }
            }

            if (!selectedCurrentCompany)
                toast.error('Firma alanını doldurunuz!')
            else if (!selectedIntegration)
                toast.error('Entegrayon Adı alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var _text = "";

                for (var i = 0; i < Object.keys(integrationValues).length; i++) {
                    var _key = Object.keys(integrationValues)[i];
                    _text += _key + " = " + integrationValues[_key] + "\n";
                }

                _text = _text.trim();

                var response: AddIntegrationSettingResponse = await IntegrationSettingService.addIntegrationSetting(integrationSettingId, selectedCurrentCompany.value, selectedIntegration.value, _text);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Firma</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCurrentCompany}
                                                onChange={setSelectedCurrentCompany}
                                                insertable={{
                                                    tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                                    onClick: () => {
                                                        dispatch(storeFastFirm({
                                                            companyId: selectedCurrentCompany?.value,
                                                            isCustomer: true,
                                                            isAgency: true,
                                                            isSupplier: true,
                                                            onSubmit: async (response) => {
                                                                setSelectedCurrentCompany({ label: response.name, value: response.companyId })
                                                            }
                                                        }))
                                                    }
                                                }}
                                                onMenuOpen={[
                                                    () => CompanyService.getCompanyList({ isCustomer: true }),
                                                    () => CompanyService.getCompanyList({ isAgency: true }),
                                                    () => CompanyService.getCompanyList({ isSupplier: true }),
                                                    () => CompanyService.getCompanyList({ isCompany: true }),
                                                ]}
                                                labelName='name'
                                                valueName='companyId'
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Entegrasyon Adı</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedIntegration}
                                                onChange={(selectedValue) => {
                                                    if (selectedValue) {
                                                        var obj: any = {};

                                                        var arr = selectedValue.additionalValue1?.split('|;|');

                                                        if (arr) {
                                                            arr.forEach((item) => {
                                                                obj[item] = '';
                                                            })
                                                        }

                                                        setIntegrationValues(obj);
                                                    }
                                                    else
                                                        setIntegrationValues(undefined);

                                                    setSelectedIntegration(selectedValue);
                                                }}
                                                onMenuOpen={() => ConstantService.getConstantList('INTEGRATION')}
                                                labelName='value'
                                                valueName='constantId'
                                                additionalValue1Name="additionalValue1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>

                        {
                            integrationValues && (
                                <KTCard className="mt-10 ebbe-card">
                                    <KTCardBody>
                                        <h4 className="mb-10 text-black">Entegrasyon Bilgileri</h4>

                                        <div>
                                            {
                                                Object.keys(integrationValues).map((item, index) => {
                                                    // Şifre, parola, secret, token ve api key alanları gizli gösterilir;
                                                    // listede de maskelenir. Görmek için "Göster" düğmesi kullanılır.
                                                    const isSecret = ['password', 'parola', 'şifre', 'sifre', 'secret', 'token', 'apikey', 'api_key'].some(x => item.toLowerCase().includes(x));
                                                    const shown = !isSecret || shownSecrets.includes(item);

                                                    return (
                                                        <div key={item} className={index == 0 ? '' : "mt-5"}>
                                                            <label className="form-label required">{item}</label>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <input style={{ border: '1px solid #F1F1F4' }} value={integrationValues[item]} onChange={(e) => setIntegrationValues({ ...integrationValues, [item]: e.target.value })} type={shown ? "text" : "password"} className="form-control form-control-solid" />
                                                                {
                                                                    isSecret && (
                                                                        <button type="button" className="btn btn-sm btn-light" onClick={() => setShownSecrets(shown ? shownSecrets.filter(x => x != item) : [...shownSecrets, item])}>
                                                                            {shown ? 'Gizle' : 'Göster'}
                                                                        </button>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </KTCardBody>
                                </KTCard>
                            )
                        }
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveIntegrationSetting}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default IntegrationSettingAdd;